export interface ProcessingSpecimen {
    Id?: number;
    OrderId?: number;
    OrderNumber?: number;
    SpecimenNo?: number;
    Status?: number;
    LabSection?: number;
    SpecimenType?: number;
    PatientId?: number;
    PatientCode?: string;
    PatientName?: string;
    PatientTypeId?: number;
    PatientSourceId?: number;
    EncounterId?: number;
    ItemCode?: string;
    ItemId?: number;
    ItemTitle?: string;
    GroupTestNo?: number;
    OrderDate?: Date;
    OrderDoctorName?: string;
    PriorityId?: number;
    CollectBy?: number;
    AvailableSpecimenNo?: number;
    AccessionMiddleSerial?: number;
    AccessionLastSerial?: number;
    AccessionNumber?: string;
    LabSectionTitle?: string;
    SectionTitle?: string;
    VisitSectionTitle?: string;
    StatusTitle?: string;
    PatientLocation?: string;
    Location?: string | number;
    BedTitle?: string;
    RoomTitle?: string;
    CivilId?: string;
    canCancelTest?: boolean;
    shareWith?: boolean;
    disabled?: boolean;
}

export interface SidebarSearchRow extends Partial<ProcessingSpecimen> {
    OrderNumber?: number;
    SpecimenTransaction?: ProcessingSpecimen;
}

export interface SidebarSearchEvent {
    result?: { data?: SidebarSearchRow[] };
}

export interface WorkbenchResponse {
    Results?: ProcessingSpecimen[];
}

export interface SpecimenTestDetail {
    Id: number;
    TestCode: string;
    TestName: string;
    LabSection: string;
    SpecimenType: string;
    AccessionMiddleSerial?: number;
    AccessionLastSerial?: number;
}

export interface OrderPriorityResult {
    OrderId: number;
    PriorityId: number;
}

export interface LookupResult {
    Id: number;
    Title: string;
}

export interface HasResultsResponse {
    hasResults: boolean;
}

export interface CheckboxToggleEvent {
    originalEvent?: Event;
}
